export const UI_DUCK = 'ui'

export const UI_SET_PAYROLL_PAGE_CURRENT_TAB = 'ui/setPayrollPageCurrentTab'
export const UI_SET_SIDE_PANEL = 'ui/setSidePanel'
export const UI_SET_ERROR_PAGE_DATA = 'ui/setErrorPageData'
export const UI_SET_CONFIRM_PASSWORD_CARD_PARAMS = 'ui/setConfirmPasswordCardParams'
export const UI_SET_NOTIFICATIONS = 'ui/setNotifications'
export const UI_SET_CUSTOM_LOADING_STATE = 'ui/customLoadingState'
export const UI_UPDATE_TRANSACTION_FORM_STATE = 'ui/updateTransactionFormState'
